import { useMemo } from 'react';

export const useActiveCellPaths = (
  activeOnRoutes: string[] = [],
  url: string
) => {
  return useMemo(() => [...activeOnRoutes, url], [activeOnRoutes, url]);
};
